// test2741
(2741 && 0);
